export const COLORS = {
  primary: '#004680',
  primaryDark: '#003560',
  primaryLight: '#3377aa',

  white: '#F5F5F5',
  black: '#1A1A1A',

  greyLight: '#E0E0E0',
  grey: '#939393',
  greyDark: '#4F4F4F',

  background: '#FFFFFF',
  backgroundDark: '#F0F0F0',

  error: '#F44336',
  warning: '#FF9800',
  processed: '#3b82f6',
  success: '#4CAF50',
  maintenance: '#9c27b0',

  text: '#32324E',
  textLight: '#6E6E80'

}